



import { useState, useEffect } from "react";
import { MenuUnfoldOutlined, MenuFoldOutlined, LogoutOutlined } from "@ant-design/icons";
import { Layout, Menu, Switch } from "antd";
const { Header, Sider, Content } = Layout;
import { Outlet, Route, Routes, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Logo from "../../Assets/Images/Left.png";
import LogoSmall from "../../Assets/Images/favicon.png";
import { logOut } from "../../Utils/UserSlice";
import { handledarkMode } from "../Elements/DarkModeAction";

const SidebarLayout = ({ items, NavItems, DefaultRoute }) => {
  const dispatch = useDispatch();
  const [collapsed, setCollapsed] = useState(false);
  const [showMenuIcon, setShowMenuIcon] = useState(true);
  const navigate = useNavigate();
  const [selectedKey, setSelectedKey] = useState(localStorage.getItem("selectedKey") || "1");
  const rs_message = useSelector((state) => state.footer.message);
  const mode = useSelector((state) => state.darkMode);
  const { isdarkMode } = mode;

  const switchDarkMode = () => {
    isdarkMode ? dispatch(handledarkMode(false)) : dispatch(handledarkMode(true));
  };

  useEffect(() => {
    document.body.style.backgroundColor = isdarkMode ? "#292c35" : "#fff";
  }, [isdarkMode]);

  const handleMenuClick = (e) => {
    const clickedKey = e.key;
    setSelectedKey(clickedKey);
    localStorage.setItem("selectedKey", clickedKey);
    const selectedItem = NavItems.find((item) => item.id === clickedKey);
    if (selectedItem) {
      navigate(selectedItem.path);
    }
  };

  const handleLogout = () => {
    navigate("/login");
    dispatch(logOut())
    localStorage.removeItem("selectedKey");
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 495) {
        setShowMenuIcon(false);
        setCollapsed(true);
      } else {
        setShowMenuIcon(true);
        setCollapsed(false);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

  return () => window.removeEventListener('resize', handleResize);
  }, []);




  return (
    <Layout className={`dark ${isdarkMode ? 'darkmode' : 'whitemode'}`}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        className={`${collapsed ? "overflow-hidden" : "overflow-auto"} h-screen z-50 md:w-64 sm:w-32 w-16`}
        onCollapse={(value) => setCollapsed(value)}
        style={{
          position: "sticky",
          top: 0,
          left: 0,
          bottom: 0,
          paddingRight: 4,
          paddingLeft: 4,
          // background: isdarkMode 
          //   ?" #2b4162 linear-gradient(35deg, #12100e 0%, #2b4162 74%)"
          //   : "linear-gradient(15deg, rgba(49, 204, 17, 1) 0%, rgba(23, 199, 75, 1) 3%, rgb(30 58 138) 29%)",
          background: isdarkMode
            ?" #2b4162 linear-gradient(315deg, #2b4162 0%, #12100e 74%)"
            : "linear-gradient(165deg, rgba(49, 204, 17, 1) 0%, rgba(23, 199, 75, 1) 3%, rgba(3, 18, 68, 1) 29%)",
        }}
      >
        <div className="demo-logo-vertical text-white text-2xl font-bold flex space-x-2 py-0 mb-16">
         {/*  <div
            className={`w-${collapsed ? "14" : "40"} p-2 ml-2 transition-all duration-300 cursor-pointer`}
            onClick={() => navigate("/landing-page")}
          >
            {!collapsed ? (
              <div className="w-40 transition delay-200  p-2 ">
                <img width="100%" height="100%" src={Logo} alt="logo" />
              </div>
            ): (
              <div className="w-40 transition delay-200">
                <img width="50px" height="100%" src={LogoSmall} alt="logo" />
              </div>
            )}
          </div> */}
        </div>
        <Menu
          theme="dark" 
          mode="inline"
          defaultSelectedKeys={[selectedKey]}
          items={items}
          className="bg-transparent font-bold z-50"
          onClick={handleMenuClick}
        />
      </Sider>
      <Layout className={`site-layout dark`}>
        <Header className={`sticky top-0 w-full bg-blue-900 z-10 shadow-md text-white ${isdarkMode ? 'headermode' : 'whitemode'} py-0`}>
          {showMenuIcon && (
            <i
              onClick={() => setCollapsed(!collapsed)}
              className={`cursor-pointer rounded-lg text-xl md:text-2xl lg:text-3xl w-6 md:w-8 lg:w-10 h-6 md:h-8 lg:h-10 absolute top-2 left-2 md:left-3 lg:left-4 ${isdarkMode ? 'headermode' : 'whitemode'}`}
            >
              {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </i>
          )}
           <div className="w-full flex justify-between items-center  ml-5 " >
            <div className="-mt-0 p-1 pt-1.5   rounded-xl">
                <img width="" height="" className=" w-48 h-10   " src={Logo} alt="logo" />
            </div>
          <p className="text-lg md:text-xl lg:text-2xl flex justify-center items-center h-[100%]  pr-2 md:pr-4 lg:pr-6 font-bold tvs-heading mt-2">
            Temperature
          </p>
          <div className="flex flex-col items-center space-y-3 md:space-y-4 lg:space-y-6 cursor-pointer font-semibold sm:w-16 sm:h-8 md:w-20 md:h-10 lg:w-24 lg:h-12 mt-2">
            <i
              className="text-xl mr-24 mt-0 cursor-pointer"
              onClick={switchDarkMode}
            >
              <Switch
                checked={isdarkMode}
                onChange={switchDarkMode}
                checkedChildren="Dark"
                unCheckedChildren="Light"
              />
            </i>
            {/* <label className="switch absolute top-4 right-8 md:right-20 lg:right-20 darktheme-switch">
            <div className="flex flex-col justify-end items-center space-x-4 cursor-pointer font-semibold">
          </div>
              <input type="checkbox" checked={isdarkMode} onChange={switchDarkMode} />
              <span className="slider "></span>
            </label> */}
            <p className="absolute -top-5 right-2 md:right-4 lg:right-6 font-bold admin-text hidden md:block text-xs md:text-sm lg:text-base">Admin</p>
            <i className="text-lg md:text-xl lg:text-2xl absolute top-0 right-2 md:right-4 lg:right-9 cursor-pointer logout-icon" onClick={handleLogout}>
              <LogoutOutlined />
            </i>
          </div>
              </div>
        </Header>
        <Content className={`h-full`}>
          <div className="p-6 bg-slate-100 h-full overflow-auto dark">
            <Routes>
              <Route path="/" element={DefaultRoute} />
            </Routes>
            <Outlet />
          </div>
        </Content>
        <div className="min-h-fit">
          <div className="h-5 bg-blue-900">
            <p className="font-mono text-sm text-white">{rs_message}</p>
          </div>
        </div>
      </Layout>
    </Layout>
  );
};

export default SidebarLayout;
